
import { useSelector  } from 'react-redux';

import { getDataModelDefinition } from '../reducers'
import { getDataModelItem } from '../reducers/dataModelDefinition'

import useDatawinDataModelItemId from './useDatawinDataModelItemId';

export default function useDatawinDataModelItem() {
    const dataModelDefinition = useSelector(state => getDataModelDefinition(state.data));
    const id = useDatawinDataModelItemId();

    return getDataModelItem(dataModelDefinition, id);
}
